module.exports = __webpack_public_path__ + "baa72870d73744ebc1541ae8da10814d.svg";